import { useTranslation } from "react-i18next";
import { Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import styles from "./Employees.module.css";
import { Button, Input } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import EmployeeCard from "../../components/Employees/EmployeeCard/EmployeeCard";

import { ReactComponent as SearchIcon } from "../../../assets/svg/search.svg";
import { PlusOutlined } from "@ant-design/icons";
import AddEmployeeDrawer from "../../components/Employees/AddEmployeeDrawer/AddEmployeeDrawer";
import Loading from "../../components/Loading/Loading";
import useEmployees from "../../components/Employees/useEmployees";
import AccessDeniedError from "../../components/ErrorComponents/AccessDeniedError";
import { ReactComponent as EmptyEmployeeIcon } from "../../../assets/svg/empty-employee.svg";

export default function Employees() {
  const [addModal, setAddModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const search = searchParams.get("q") || "";
  const { data, errorStatus, loadMoreRef, isLoading, refetch } =
    useEmployees(search);
  const isEmpty = useMemo(
    () => !isLoading && data.length === 0,
    [JSON.stringify(data), isLoading]
  );
  const accessDenied = useMemo(
    () => !isLoading && errorStatus === 403,
    [errorStatus, isLoading]
  );
  const initialLoading = useMemo(
    () => data.length === 0 && isLoading,
    [JSON.stringify(data), isLoading]
  );

  const debouncedSearchFn = useCallback(
    _.debounce((value) => {
      setSearchParams((prevState) => {
        prevState.set("q", value);
        return prevState;
      });
    }, 500),
    []
  );

  useEffect(() => {
    if (addModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [addModal]);

  return (
    <Page
      bodyWrapperClassName={styles.AppointmentPage}
      footer={null}
      customHeader={<HeaderBack url={"/"} title={t("drawer.employees")} />}
      headerFix
      showFooter={false}
      customPageClassName={styles.page}
    >
      {accessDenied ? (
        <AccessDeniedError />
      ) : (
        <>
          <div className={styles.container}>
            <Input
              defaultValue={search}
              onChange={(e) => {
                debouncedSearchFn(e.target.value);
              }}
              variant="borderless"
              className={styles.searchInput}
              prefix={<SearchIcon className={styles.searchIcon} />}
              placeholder={t("common.search")}
            />

            {initialLoading ? (
              <div className="text-center mt-5">
                <Loading />
              </div>
            ) : (
              <>
                {data.map((employee) => (
                  <EmployeeCard
                    id={employee.id}
                    key={employee.id}
                    is_active={employee.is_active}
                    mobile_number={employee.mobile_number}
                    number_of_bills={employee.number_of_bills}
                    full_name={`${employee.first_name || ""} ${
                      employee.last_name || ""
                    }`}
                  />
                ))}
                {isLoading && (
                  <div className="text-center mt-5">
                    <Loading />
                  </div>
                )}
                <div
                  ref={loadMoreRef}
                  style={{ height: "10px", background: "tranparent" }}
                />
              </>
            )}
            {isEmpty ? (
              <div className={styles.emptyEmployee}>
                <EmptyEmployeeIcon />
                <p>{t("employees.empty")}</p>
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  style={{
                    fontWeight: "bold",
                  }}
                  onClick={() => setAddModal(true)}
                >
                  {t("employees.add")}
                </Button>
              </div>
            ) : null}
          </div>
          {data.length !== 0 && (
            <div className={styles.addButtonContainer}>
              <Button
                type="primary"
                size="large"
                onClick={() => setAddModal(true)}
              >
                <PlusOutlined
                  style={{
                    fontSize: "24px",
                    color: "#fff",
                  }}
                />
              </Button>
            </div>
          )}
          <AddEmployeeDrawer
            open={addModal}
            onClose={() => setAddModal(false)}
            refetch={refetch}
          />
        </>
      )}
    </Page>
  );
}
